import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: "#00c0e7",
				secondary: "#009f4a",
				error: "#ff5546",
				info: "#2196F3",
				warning: "#FFC107",
				success: "#50D791",
			},
		},
		options: {
			customProperties: true,
			variations: true,
		},
		icons: {
			iconfont: "mdi",
		},
	},
});
